import _ from 'lodash';
import { createApp, defineComponent } from 'vue';
import GridPredecessorsCellEditor from './GridPredecessorsCellEditor.vue';
import Links from '../../../controllers/links';
import KeyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridPredecessorsCellEditor);

      const task = instance.getTask(id);
      const tasksForSearch = [];

      instance.eachTask(item => {
        if (item.gantt_id === task.gantt_id && item.type !== instance.config.types.button) {
          const wbs = instance.getWBSCode(item);

          if ((item.parent && !(instance.config.multiview && item.parent === 1)) && item.id !== task.id) {
            tasksForSearch.push({
              id: item.id,
              value: item.text,
              wbs,
            });
          }
        }
      });

      const onSave = () => {
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        tasksForSearch,
        onSave,
        onCancel,
      });
      vueInstance = vueApp.mount(placeholder);

      KeyboardNavigation.toggleState(false);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;

      KeyboardNavigation.toggleState(true);
    },

    set_value(task, id, column, node) {
      const links = task.$target || [];
      const linkFormater = instance.ext.formatters.linkFormatter();

      vueInstance.value = links.map(link => {
        const linkObj = {
          ...instance.getLink(link),
          type: '0',
          lag: 0,
        };

        return linkFormater.format(linkObj);
      }).join(', ');
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(value, id, column, node) {
      return value !== vueInstance.value;
    },

    is_valid(value, id, column, node) {
      return true;
    },

    save(id, column, node) {
      const values = vueInstance.value?.split(',')?.map(wbs => wbs.trim()) || [];
      const wbsItems = _.uniq(values.filter(value => value.length));

      Links.predecessorColumnChange(id, wbsItems);
    },

    focus(node) {
    },
  };
}
